import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseEditService } from '../../base';
import { PurchaseOrderLineProduction } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderLineProductionService extends TmsWebBaseEditService<
  PurchaseOrderLineProduction,
  PurchaseOrderLineProduction
> {
  constructor() {
    super('PurchaseOrderLineProductionItem', $localize`Purchase Order Line Production`);
  }

  receiveProductionItems(productionItems: PurchaseOrderLineProduction[]): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/ReceiveProductionItems`, { productionItems });
  }
}
